import { service, openApi } from '@/utils/request'

export default {
  login (payload) {
    return service.post('/Login/LoginByTel', payload)
  },
  pcLogin (payload) {
    return service.post('/Login/LoginByToken', payload)
  },
  checkIsRegistered (phone) {
    return service.get(process.env.VUE_APP_RCCL + '/api/Orchard.Rccl.Users/LoginApi/IsRegistered', {
      params: {
        phone
      }
    })
  },
  checkIsMember (phone) {
    return service.get(process.env.VUE_APP_RCCL + '/Rccl.OpenApi/User/IsRegisteredMember', {
      params: {
        phone
      }
    })
  },
  checkHasRegister (telephone, callingCode) {
    return openApi.post(process.env.VUE_APP_RCCL + '/Rccl.OpenApi/User/CheckHasRegister', {
        telephone, callingCode
    })
  },
  bindBooking (payload) {
    return service.post('/Booking/BindBooking', payload)
  },
  bindOut (payload) {
    return service.post('/Booking/BindOut', payload)
  },
  getBookingInfo (isGetMajorGuests = false) {
    return service.get('/Booking/GetBookingAndCruiseInfo',
    {
      params: {isGetMajorGuests}
    })
  },
  getIndex () {
    return service.get('/Home/GetAll')
  },
  getProductListByCategory (categoryName, shipCode) {
    return service.get('/Product/GetProductListByCategory', {
      params: { categoryName, shipCode }
    })
  },
  getProductDetail (productId) {
    return service.get('/Product/Detail', {
      params: { productId }
    })
  },
  getProductShorex (cityName) {
    return service.get('/Product/PcpShorex', {
      params: { cityName }
    })
  },
  getShoppingCartsList () {
    return service.get('/ShoppingCart/ShoppingCarts')
  },
  getSmShoppingCartsList () {
    return service.get(process.env.VUE_APP_SMAPI + '/SMAPIShoppingCart/Cart')
  },
  getPackageProducts (payload) {
    return service.get('/ProductInv/GetPackageProductsInvs', {
      params: payload
    })
  },
  getCanSelectGuestsByProduct (payload) {
    return service.post('/Order/GetCanSelectGuestsByProduct', payload)
  },
  addProduct (payload) {
    return service.post('/Order/AddProduct', payload)
  },
  editProduct (payload) {
    return service.post('/Order/EditProduct', payload)
  },
  getHotSearch () {
    return service.get('/Search/GetHotSearchKeywords')
  },
  searchProductByName (payload) {
    return service.get('/Search/SearchByName', {
      params: payload
    })
  },
  deleteProduct (payload) {
    return service.post('/Order/deleteProduct', payload)
  },
  getQuestion () {
    return service.get('/FAQ/GetPCPFAQ')
  },
  submitOrder (payload) {
    return service.post('/Order/SubmitOrder', payload)
  },
  getOrderDetail (payload) {
    return service.get('/OrderDetail/CheckOut', {
      params: payload
    })
  },
  getOriginOrderDetail () {
    return service.get('/OrderDetail/OriginOrder')
  },
  getPictureCode () {
    return service.get('/Util/PictureVerificationCode')
  },
  getMsgVerifyCode (payload) {
    return service.post('/Sms/GetVerifyCode', payload)
  },
  checkOrderStatus () {
    return service.get('/Order/CheckStatus')
  },
  editOrder () {
    return service.post('/Order/EditOrder')
  },
  getPopupMessage () {
    return service.post('/Message/GetPopupMessage', { type: 2 })
  },
  getCombos (payload) {
    return service.get('/Combo/GetCombos', {
      params: payload
    })
  },
  getBookingOrderInfo (payload) {
    return service.get('/Booking/GetBookingAndOrderInfo', {
      params: payload
    })
  },
  getNewsList (payload) {
    return service.get('/News/GetAllNews', {
      params: payload
    })
  },
  getNewsDetail (payload) {
    return service.get('/News/GetNewsDetail', {
      params: payload
    })
  },
  getQrCode (payload) {
    return service.get('/Message/GetQrCode', {
      params: payload
    })
  },
  getUrlToShoppingMall (page) {
    return service.get('/RedirectToSM/RedirectToShoppingMall', {
      params: { page }
    })
  },
  // 查询未出行订单
  getBookingsByBookingOrderId (payload) {
    return service.post('/Booking/GetBookingsByBookingOrderId', payload)
  },
  loginAndBindingFromBookingMiniApp (payload) {
    return service.post('/Booking/LoginAndBindingFromBookingMiniApp', payload)
  },
  getSMOrderState () {
    return service.get(process.env.VUE_APP_SMAPI + '/SMAPIOrder/GetOrderState')
  },
  getCallingCode () {
    return service.post('/Util/GetCallingCodes')
  },
  //检查隐私版本是否是最新的

  getUserVersionIsEffective (userName) {
    return openApi.post(process.env.VUE_APP_RCCL+"/Rccl.OpenApi/User/GetUserVersionIsEffective", { userName })
  },
  //同意隐私协议
  agreePrivacyPolicy (userName) {
    return openApi.post(process.env.VUE_APP_RCCL+"/Rccl.OpenApi/User/AgreePrivacyPolicy", { userName })
  },
  // 获取用户是否开启隐私保护
  changePrivacyProtectionIsOpen (userName) {
    return openApi.post(process.env.VUE_APP_RCCL+"/Rccl.OpenApi/UserCenter/ChangePrivacyProtectionIsOpen", { userName })
  },
  // 更新用户是否开启隐私保护
  updateUserPrivacyProtection (requestData) {
    return openApi.post(process.env.VUE_APP_RCCL+"/Rccl.OpenApi/UserCenter/UpdateUserPrivacyProtection", requestData)
  }

}
